<!-- 法律文书管理子表（审批流程） -->
<template>
  <m-table
    ref="table"
    :loadObj='{}'
    :option="{}"
    :colObj='{
      opId:"114",
      name:"编辑操作的具体数据",
      parentId:"LOG_ID",
      parentName:"编辑操作的具体数据",
      parentPath:"/system/editLog",
      dataClass:2,
    }'>
  </m-table>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      firstEnter:true,
    };
  },
  computed: {
  },
  methods: {
  },
  created(){
    // console.log('1');
  },
  activated(){
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
